import React, { useState, useEffect } from "react";

const ProgressBar = (props) => {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		setProgress(parseInt(props.progressValue));
	}, [props.progressValue]);

	return (
		<div
			style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
		>
			<div
				style={{
					borderRadius: "var(--borderRadius)",
					overflow: "hidden",
					width: "300px",
					height: "20px",
					margin: "10px",
					backgroundColor: 'rgba(255,255,255,0.2)'
				}}
			>
				<div
					style={{
						width: `${progress}%`,
						height: "100%",
						backgroundColor: props.color ?? "#4CAF50",
						transition: "width 0.5s",
					}}
				/>
			</div>
		</div>
	);
};

export default ProgressBar;
